import { render, staticRenderFns } from "./DharmasSearch.vue?vue&type=template&id=13a607b4&"
import script from "./DharmasSearch.vue?vue&type=script&lang=js&"
export * from "./DharmasSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports